// Angular Imports
import { Component, OnInit, inject } from '@angular/core'
import { Location } from '@angular/common'
import { Router } from '@angular/router'
// Shared Imports
import { RegisterSvgAsIconService } from '@shared/services'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	readonly #registerSvgAsIcon = inject(RegisterSvgAsIconService)
	readonly #router = inject(Router)
	readonly #location = inject(Location)

	ngOnInit() {
		// Removemos los tokens de la url luego de hacer login
		const searchParams = new URLSearchParams(this.#location.path(false).split('?')[1])
		searchParams.delete('access-token')
		searchParams.delete('refresh-token')

		let urlWithoutTokensParams: string = ''
		searchParams.toString()
			? (urlWithoutTokensParams = `${
					this.#location.path().split('?')[0]
				}?${searchParams.toString()}`)
			: (urlWithoutTokensParams = `${this.#location.path().split('?')[0]}`)

		this.#router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.#router.navigateByUrl(urlWithoutTokensParams)
		})
	}
}
